<template>
    <div class="col-lg-6 col-md-12 col-sm-12 boton-panel">
        <md-card md-with-hover md-theme="inverso" >
            <md-ripple >
                <md-card-media >
                    <v-lazy-image
                            :src="imagen"
                            :alt="datos.dt2"
                            :src-placeholder="spiner"
                            :use-picture="true"
                    />
                </md-card-media>
                <md-card-header >
                    <div class="md-title text-truncate">{{datos.dt2}}</div>
                </md-card-header>
                <md-card-content >
                    <div v-html="html" class="text-capitalize"></div>
                </md-card-content>
                <md-card-actions md-alignment="left" class="pb-1 letra d-flex justify-content-between">
                    <div class="pl-2">
                        <md-checkbox :value="true" v-model="seleccion"  v-on:change="elegir" />
                    </div>
                    <div>
                        <md-button md-dense class="sin-p" :class="seleccion ? 'md-accent' : '' " v-on:click="elegir">{{seleccion ? "Seleccionado" : "Agregar"}}</md-button>
                    </div>
                    <div v-if="datos.elements2">
                        <md-button md-dense class="sin-p" v-on:click="vermas=!vermas"><span class="md-caption">ver más</span></md-button>
                    </div>
                </md-card-actions>
            </md-ripple>
        </md-card>
        <md-drawer  mdPersistent="full" class="md-right" mdFixed :md-active.sync="vermas" md-theme="inverso" v-if="datos.elements2">
            <md-toolbar class="md-transparent d-flex justify-content-between" md-elevation="5">
                <div  class="md-title p-2"><i class="flaticon2-box-1"></i> Detalles</div>
                <div class="p-2">
                    <button type="button" class="close" v-on:click="vermas=false">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
            </md-toolbar>
            <md-list>
                <md-list-item v-for="item in datos.elements2" :key="item.id">
                    <div class="col-5">
                        <p class="text-capitalize">{{minusculas(item.dt1)}}</p>
                    </div>
                    <div class="col-7">
                        <div class="text-center">
                            <img :src="api+item.dt4" class="rounded img-fluid" :alt="item.dt1">
                        </div>
                    </div>
                </md-list-item>
            </md-list>
        </md-drawer>
    </div>
</template>
<script>
    import VLazyImage from "v-lazy-image";
    import constantes from "../constantes";
    export default {
        name: "boton-panel",
        data:()=>({
            api:process.env.VUE_APP_URL_API,
            spiner:require("../assets/images/default_paquete.jpg"),
            vermas:false,
            seleccion:false,
            imagen:null,
            value:{id:null},
            html:null,
        }),
        props:{
            datos:{
                type:Object,
                default:()=>({
                    id:null,
                    elements2: []
                })
            },
            valor:{
                type:Object,
                default:()=>({
                    id:null
                })
            }
        },
        components:{
            VLazyImage
        },
        watch:{
            valor:function(nuevo){
                this.seleccion = nuevo.id === this.datos.id;
            }
        },
        methods:{
            minusculas:(texto)=>constantes.funciones.minusculas(texto),
            validarSeleccion:function() {
                this.value = this.valor;
                this.seleccion = this.valor.id === this.datos.id;
            },
            elegir:function(){
                this.validarSeleccion();
                this.$emit('input',this.datos);
            },
        },
        created() {
            this.validarSeleccion();
            this.imagen = this.datos.dt4 ? process.env.VUE_APP_URL_API + this.datos.dt4 : require('../assets/images/default_paquete.jpg');
            this.html=this.minusculas(this.datos.dt1);
        },
        updated() {
            this.validarSeleccion();
        }
    }
</script>

<style scoped>
    .boton-panel{
        padding-bottom: 15px;
    }
    .text-capitalize{
        white-space: pre-wrap;
        font-size: 12px;
    }
    .md-title{
        font-size: 1.2rem;
    }
    .v-lazy-image {
        filter: blur(30px);
        transition: filter 0.8s;
    }
    .v-lazy-image-loaded {
        filter: blur(0);
    }
    .md-button{
        font-size: 12px;
        padding: 0px !important;
    }
    .sin-p{
        padding: 0px !important;
    }
</style>
